import { filesAPIService } from '~/api/files';
import { getFileFromLocalSource } from '~/utils/common';

export const uploadLinksDataWithImages = async (linkList, redux) => {
  const uploadPromises = linkList.map(async (item, index) => {
    const file = await getFileFromLocalSource(`${window.location.origin}${item.previewLink}`);
    const storageResponse = await filesAPIService.uploadImage(file);

    if (redux) {
      redux.dispatch(
        redux.actions.setContentLinkListValues({ field: 'imageStorageId', value: storageResponse.data, index }),
      );
    }

    return { photo_id: storageResponse.data, url: item.url, text: item.linkText, position: index };
  });

  const links = await Promise.all(uploadPromises);

  return links;
};

export const updateImagesData = async (imagesList, redux, micrositeId, isStorageId) => {
  const uploadPromises = imagesList.map(async (item, index) => {
    const file = await getFileFromLocalSource(`${window.location.origin}${item.img}`);
    const storageResponse = await filesAPIService.uploadImage(file);

    if (isStorageId) {
      redux.dispatch(
        redux.actions.setContentImagesValues({ field: 'imageStorageId', value: storageResponse.data, index }),
      );
    }

    return {
      image_id: storageResponse.data,
      title: file?.name || '',
      size: item?.size,
      microsite: micrositeId,
    };
  });

  const images = await Promise.all(uploadPromises);

  return images;
};

export const getStatsFromQrCodeData = (qrcodeData) => {
  return {
    isAutogeneratedUrl: !!qrcodeData?.isAutogeneratedUrl,
    url: qrcodeData?.uri || '',
    isLimitsEnabled: !!qrcodeData?.scanLimit?.toString(),
    scan: qrcodeData?.scanLimit?.toString() || '',
  };
};
